import type {MetricsDashboardDto} from '@devmil/contracts';

import {usePanel} from '../../app/PanelProvider.js';

export const useMetricsDashboard = (): MetricsDashboardDto | null =>
  usePanel().snapshot?.metrics ?? null;
